// extracted by mini-css-extract-plugin
module.exports = {"article":"RebatesItem_article__41pO9","priceBlock":"RebatesItem_priceBlock__HHOuC","title":"RebatesItem_title__N1EYY","price":"RebatesItem_price__sNTFW"};